/**
 * 个人中心 父类
 * @author yuxin.zhang
 * @Date 2017-05-09
 */

import * as reactGa from '_common/reactGa';

import Page from '../../constants/PageLink';
import * as req from '../../utils/req';
import RootContext from '../RootContext';

export default class AccountContext extends RootContext {
  /** *
   * 显示错误信息个人中心各个页面引用
   * 将错误信息设置到对应的state 的errorMsg
   * @param msg
   */
  showErrorMsg = (msg) => {
    this.setState({
      errorMsg: msg,
    });
  };

  /**
   * 弹框关闭事件
   */
  closeDialog = () => {
    this.toggleDialog(false, false);
  };

  /** *
   * 切换弹框显示
   * @param showDialog
   * @param showLoading
   */
  toggleDialog = (showDialog, showLoading) => {
    this.setState({
      showDialog,
      showLoading,
    });
  };

  /**
   * 切换Loading
   * @param showLoading
   */
  toggleLoading = (showLoading) => {
    this.setState({
      showLoading,
    });
  };

  /**
   * 切换按钮加载中状态
   * @param btnLoading
   */
  toggleBtnLoading = (btnLoading) => {
    this.setState({
      btnLoading,
    });
  };

  /**
   * 失焦事件
   * @param e
   */
  inputBlur = (e, isPassword = false, isPasswordContent = '') => {
    this.setState({
      blurItem: e.target.getAttribute('rel'),
    });
    if (isPassword === true && !isPasswordContent?.length) {
      this.setState({
        showPasswordError: false,
      });
    }
  };

  // 获取焦点事件
  inputFocus = (e, isPassword = false) => {
    this.setState({
      focusItem: e.target.getAttribute('rel'),
      blurItem: '',
    });
    if (isPassword === true) {
      this.setState({
        showPasswordError: true,
      });
    }
  };

  /**
   * 跳转安全中心
   */
  toVerificationPage = () => {
    const { securityStore } = this.props;
    securityStore.getSecurityInfo(true);
    this.linkTo(Page.verification);
  };

  /**
   * 跳转安全中心
   */
  toSecurityPage = () => {
    const { securityStore } = this.props;
    securityStore.getSecurityInfo(true);
    this.linkTo(Page.security);
  };

  /** ** 验证相关 *** */

  /** *
   * 处理 二次验证标志
   * @param t
   * @returns {{needGoogle: boolean, needSms: boolean, needEmail: boolean, disabled: boolean}}
   */
  dealVerifyType = (t) => {
    const type = Number(t);
    return {
      needGoogle: type === 0 || type === 3 || type === 4 || type === 6,
      needSms: type === 1 || type === 3 || type === 5 || type === 6,
      needEmail: type === 2 || type === 4 || type === 5 || type === 6,
      onlyNeedLoginPWD: type === 7,
      disabled: type === -1,
    };
  };

  // 验证码变化回调   从各自父组件传入  CodeBox 调用
  verifyChange = (data) => {
    this.setState({ verifyData: data, errorMsg: '' });
  };

  // 验证码错误回调  从各自父组件传入  CodeBox 调用
  verifyError = (errorMsg) => {
    this.showErrorMsg(errorMsg);
  };

  // 验证码清理回调 从各自父组件传入 CodeBox 调用
  verifyClean = () => {
    this.setState({ isClean: false });
  };

  // 清理CodeBox
  cleanCodeBox = () => {
    this.setState({ isClean: true });
  };

  // 安全中心每个设置的更改都会有个前置的GO接口 用来判断是否可以更改以及会需要什么验证码  除了URL都一样
  getGo = (url, successCallback, errorCallback, showErrorMsgAlways) => {
    const { verifyStore } = this.props;
    this.showLoading();
    req.getData(
      url,
      (res) => {
        verifyStore.dealVerifyType(res.data.type);
        // verifyStore.closeSwitchGoogleSms();
        this.setState({
          behavior: res.data.behavior,
        });
        this.hideLoading();
        successCallback && successCallback(res);
      },
      (res) => {
        // 这句用于更改页面上的错误信息
        this.showErrorMsg(res.msg, showErrorMsgAlways);
        // 这句回调 用于 弹框更新错误信息  因为弹框统一放到父级  所以不能用上句
        errorCallback && errorCallback(res.msg);
        this.hideLoading();
      }
    );
  };

  eventRegisterGA = () => {
    reactGa.eventRegisterGA();
  };

  eventKycStepGA = (step) => {
    reactGa.eventKycStepGA(step);
  };

  eventKycSubmitGA = () => {
    reactGa.eventKycSubmitGA();
  };

  eventThirdPartyConversation = () => {
    reactGa.eventThirdPartyConversation();
  };
}
